import { type TFunction } from 'react-i18next';
import {
  LoopStepTypes,
  type ExecutionHistory,
  type HistoryStatus,
  type Step,
} from 'pages/AutomationEngine/types';
import { HISTORY_STATUS_CONFIG } from './contants';
import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

export const getHistoryStatusColor = (status?: HistoryStatus | 'running') => {
  return (status && HISTORY_STATUS_CONFIG[status]?.color) || 'background-light';
};

export const getHistoryStatusLabel = (
  status: HistoryStatus | 'running' | undefined,
  t: TFunction
) => (status && HISTORY_STATUS_CONFIG[status]?.label(t)) || t('Unknown');

export const getHistoryStatusIcon = (
  status: HistoryStatus | 'running' | undefined
) =>
  (status && HISTORY_STATUS_CONFIG[status]?.icon) || 'message-warning-triangle';

export const getStatusDecoration = (
  history: ExecutionHistory,
  step: Step | undefined | null,
  t: TFunction
) => {
  if (history.stepOutput === null || !step) {
    return history.stepOutput;
  }

  if (
    step.type === LoopStepTypes.LOOP ||
    step.type === LoopStepTypes.LOOP_NEXT_OR_FINISH ||
    step.type === AUTOMATION_STEPS.exit_loop.type
  ) {
    return null;
  }

  if (step.type === 'goal') {
    return history.stepOutput ? t(' (Met Path)') : t(' (Not Met Path)');
  }

  return history.stepOutput ? t(' (Yes Path)') : t(' (No Path)');
};
